export default "__VITE_ASSET__3933de68__"